import { useStaffSnapshot } from "@/context/AppContext";
import { StatusBadge } from "@/components/schedora/StatusBadge";

const today = new Date().toISOString().slice(0, 10);

export default function StaffSchedule() {
  const snapshot = useStaffSnapshot(today);

  if (!snapshot) {
    return (
      <div className="rounded-xl border border-dashed bg-card p-6 text-sm text-muted-foreground">
        Your staff profile is still syncing. Please refresh in a moment.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-heading font-bold text-foreground">My Schedule</h1>
        <p className="text-sm text-muted-foreground">See every scheduled appointment assigned to you, including client and service details.</p>
      </div>

      <div className="space-y-3">
        {snapshot.appointments.map((appointment) => (
          <div key={appointment.id} className="rounded-xl border bg-card p-5 shadow-soft">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <h2 className="font-semibold text-foreground">{appointment.serviceName}</h2>
                <p className="text-sm text-muted-foreground">{appointment.clientName}</p>
                <p className="mt-1 text-xs text-muted-foreground">
                  {appointment.date} · {appointment.timeLabel} · ${appointment.servicePrice}
                </p>
              </div>
              <StatusBadge status={appointment.status} />
            </div>
          </div>
        ))}
        {snapshot.appointments.length === 0 && (
          <div className="rounded-xl border border-dashed bg-card p-6 text-sm text-muted-foreground">
            No appointments have been assigned to you yet.
          </div>
        )}
      </div>
    </div>
  );
}
